import {
  user,
  business,
  cart,
  myOrder,
  clearCart,
  menuDraft,
  addVisit,
  showPopup,
  orderOnLogin,
  loading,
  isAdmin,
  orders,
  userDetails,
  loyaltyRules,
  fcmToken,
  OS,
} from "../stores.js";
import { get } from "svelte/store";
import * as UserDAL from '../dal/user-dal'
import * as OrderDAL from '../dal/order-dal'
import * as AuthBL from '../bl/auth-bl'

let browserRef;

function buildOrderObject(fcmToken) {
  let u = get(user);
  let c = get(cart);


  if (Object.keys(c.items) == 0) {
    console.log("cart is empty");
    return false;
  }

  let items = [];
  let sum = 0;
  let categories = {};

  Object.keys(c.items).forEach((item) => {
    let i = c.items[item];

    items.push({
      name: i.name,
      checkboxes: i.checkboxes,
      options: i.options,
      count: i.count,
      price: i.price,
      total: i.price * i.count,
      section: i.section,
      awardedByRule: i.awardedByRule,
      numOfFreeItems: i.numOfFreeItems
    });

    if (i.category)
      categories[i.category] = true;

    sum += i.price * i.count;

    if (i.awardedByRule) sum -= i.price;
  });

  categories = Object.keys(categories);

  return {
    userId: u.uid,
    phoneNumber: u.phoneNumber,
    userFcmToken: fcmToken,
    orderId: u.phoneNumber.substr(-3),
    businessId: c.details.code,
    businessTitle: c.details.title,
    notes: c.details.notes,
    items,
    sum,
    categories
  };
}


export function gotoPayment() {
  const paymentUrl = get(myOrder).paymentUrl;
  if (!paymentUrl) return;
  if (window.cordova) {
    window.open(paymentUrl, '_blank');
    window.location.reload();
    // browserRef = cordova.InAppBrowser.open(paymentUrl, '_blank', 'location=no');
    // browserRef.addEventListener('loadstart', loadStartCallBack);
  } else {
    window.location.assign(paymentUrl);
  }
}

function loadStartCallBack(e) {
  console.log(e.url)
  const { hostname } = new URL(e.url);
  if (hostname != 'sandbox.meshulam.co.il' && hostname != 'secure.meshulam.co.il') {
    browserRef.close();
  }
}



export async function order(addressDetails) {
  let b = get(business);
  let token = get(fcmToken);
  try {
    if (await AuthBL.checkLogin()) {
      loading.set(true);

      let order = buildOrderObject(token);

      if (addressDetails) {
        let address = `${addressDetails.street} ${addressDetails.streetNumber}, ${addressDetails.city.name}`
        order.deliveryDetails = {
          address,
          price: b.deliverySettings.price
        }
        order.sum += b.deliverySettings.price;
      }

      console.log('subscribing to myorder')
      const myOrderUnsub = myOrder.subscribe((o) => {
        console.log('myOrder.subscribe')
        console.log(o)
        if (o?.paymentUrl) {
          console.log('goiing to payment')
          myOrderUnsub();
          gotoPayment();
        }
      });
      await db.callable("order", order);

      loading.set(false);
      const os = get(OS);
      if (window.cordova && os.toLowerCase() == "ios") {
        FirebasePlugin.hasPermission(function (hasPermission) {

          console.log("Permission check returned " + (hasPermission ? "granted" : "denied"));
          if (!hasPermission) {
            showPopup('תרצו לקבל התראה כשהמנה מוכנה לאיסוף?', async () => {
              FirebasePlugin.grantPermission(function (hasPermission) {
                console.log("Permission was " + (hasPermission ? "granted" : "denied"));
              });
            });
          }
        });

      }
    } else {
      orderOnLogin.set(true);
    }
  } catch (e) {
    loading.set(false);
    showPopup("...משהו השתבש", () => { });
    UserDAL.sendLog("order button click", e.toString());
  }
}




export function listenToMyOrder() {
  console.log('in listenToMyOrder')
  let u = get(user);
  console.log('user:' + u)
  if (!u) return Promise.reject("not logged in");
  console.log('calling listenToUserOrders')

  OrderDAL.listenToUserOrders(u.uid, updatedOrders => {
    console.log('in listenToUserOrders callback')
    console.log(updatedOrders)

    if (!updatedOrders || updatedOrders.length == 0) return myOrder.set(null);

    let latestOrder;
    updatedOrders.forEach(o => {
      if (!latestOrder || o.createdAt.seconds > latestOrder.createdAt.seconds) {
        console.log('i am latest order:')
        console.log(o)
        latestOrder = o;
      }
    })
    console.log('setting latestOrder')
    console.log(latestOrder)

    console.log(`order.status: ${latestOrder.status}`)
    myOrder.set(latestOrder);
    if (latestOrder.status == "waiting") {
      clearCart();
    }
  })
}

